import React, { useCallback, useEffect, useState } from "react";
import { Link,useHistory } from "react-router-dom";
import { Row, Col, Card, Table, Spin, Button, Input, Divider, notification, Modal, Select, Avatar } from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import { FileExcelOutlined, EyeOutlined, UserOutlined, SaveOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { hasPermission } from '../../components/permissions';
import '../../assets/styles/custom_style.css';
import moment from 'moment';
import * as XLSX from 'xlsx';
import 'antd/dist/antd.css';

const { Option } = Select;

const createStyledTitle = (text) => (
  <span style={{ fontSize: '13px', color: '#7a0000', fontWeight: 700 }}>{text}</span>
);

function CalendarReport() {

  const history = useHistory();

  const [userList, setUserList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false); // State to manage the loade
  const [filters, setFilters] = useState({
    name: '',
    email: '',
    phone: '',
    is_calendar: '',
    calendar_per_name: '',
    no_calendar: '',
    village: '',
    is_honored: ''
 
  });
  const [isResponseModalVisible, setIsResponseModalVisible] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [responsePagination, setResponsePagination] = useState({});
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    getUserList();
  }, []);

  const columns = [
    {
      title: createStyledTitle("S.No"),
      dataIndex: "key",
      key: "key",
      fixed: 'left',
      width: 55,
      render: (text) => <span style={{ fontWeight: 600, fontSize: 12, color: '#7a0000' }}>{text}</span>,
    },
    {
      title: createStyledTitle("Name"),
      dataIndex: "name",
      key: "name",
      fixed: 'left',
      width: 220,
    },
    {
      title: createStyledTitle("Phone"),
      dataIndex: "phone_no",
      key: "phone_no",
      width: 130,
    },
    {
      title: createStyledTitle("Calendar"),
      dataIndex: "is_calendar",
      key: "is_calendar",
      width: 100,
    },
    {
      title: createStyledTitle("No. Of Calendar"),
      dataIndex: "no_calendar",
      key: "no_calendar",
      width: 120,
    },
    {
      title: createStyledTitle("Person/Village"),
      dataIndex: "calendar_per_name",
      key: "calendar_per_name",
      width: 150,
    },
    {
      title: createStyledTitle("Honored"),
      key: "is_honored",
      dataIndex: "is_honored",
      width: 100,
    },
    {
      title: createStyledTitle("Village"),
      key: "per_village",
      dataIndex: "per_village",
      width: 120,
    },
  ];

  const [editingKey, setEditingKey] = useState('');
  const [editingResponse, setEditingResponse] = useState('');
  const [editingResponseForBackup, setEditingResponseForBackup] = useState('');

  const isEditing = (key) => key === editingKey;

  const editResponse = (key, text) => {
    setEditingKey(key);
    setEditingResponse(text);
    setEditingResponseForBackup(text);
  };

  const cancelEdit = () => {
    setEditingKey('');
    setEditingResponse('');
    setEditingResponseForBackup('');
  };

  const saveResponse = async (key) => {
    try {
      if (editingResponse === editingResponseForBackup) {
        setEditingKey('');
        setEditingResponse('');
        setEditingResponseForBackup('');
      } else {
        const response = await axios.put(`${baseUrl}/users/updateResponse`, {
          user_id: key,
          latest_payment_response: editingResponse
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          }
        });
        if (response.data.status) {
          notification.success({
            message: 'Success',
            description: 'Response updated successfully',
            placement: 'topRight'
          });
          getUserList(currentPage, limit, sortField, sortOrder, search, filters);
        } else {
          notification.error({
            message: 'Error',
            description: response.data.message,
            placement: 'topRight'
          });
        }
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }

    setEditingKey('');
    setEditingResponse('');
    setEditingResponseForBackup('');
  };

  const handleKeyDown = (e, userId) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default behavior (e.g., new line in textarea)
      saveResponse(userId);
    }
  };

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  async function getUserList(page = 1, limit = 20, sortField = null, sortOrder = null, search = '', filters = {}) {
    try {
      setCurrentPage(page);
      setLimit(limit);
      const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
      const searchParam = search ? `&search=${search}` : '';
      const filterParams = Object.keys(filters)
        .map(key => `${key}=${filters[key]}`)
        .join('&');
      const response = await axios.get(`${baseUrl}/reports/calendarReport?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setUserList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: 'Info',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === 'ascend' ? 'asc' : 'desc';
    setSortField(field);
    setSortOrder(formattedOrder);
    setFilters(filters);
    getUserList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleSearch = value => {
    setSearch(value);
    getUserList(currentPage, limit, sortField, sortOrder, value, filters);
  };

  const handleLimitChange = value => {
    setLimit(value);
    getUserList(1, value, sortField, sortOrder, search, filters);
  };

  const debouncedGetUserList = useCallback(debounce((page, limit, sortField, sortOrder, search, filters) => {
    getUserList(page, limit, sortField, sortOrder, search, filters);
  }, 300), []);

  useEffect(() => {
    const filterKeys = Object.keys(filters);

    // Check if any filter other than 'createdBy' has a length of 3 or more
    const anyFilterHasMinLength = filterKeys.some(
      key => key !== 'createdBy' && filters[key].length >= 1
    );

    // Check if all filters are either empty or specifically 'createdBy'
    const allFiltersEmptyOrCreatedBy = filterKeys.every(
      key => key === 'createdBy' || !filters[key]
    );

    if (anyFilterHasMinLength || allFiltersEmptyOrCreatedBy) {
      debouncedGetUserList(currentPage, limit, sortField, sortOrder, search, filters);
    }
  }, [filters, currentPage, limit, sortField, sortOrder, search]);

  const handleFilterChange = (field, value) => {
    setFilters({
      ...filters,
      [field]: value
    });
  };

  const exportToExcel = async () => {
    setLoading(true);
    const sortParam = sortField && sortOrder ? `&sortField=${sortField}&sortOrder=${sortOrder}` : '';
    const searchParam = search ? `&search=${search}` : '';
    const filterParams = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&');
    const response = await axios.get(`${baseUrl}/reports/calendarReport?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      }
    });
    if (response.data.status) {
      setLoading(false);

      const minYear = response.data.minYear;  // Ideally, get this from the backend or use a predefined year
      const maxYear = response.data.maxYear;  // Ideally, get this from the backend or use a predefined year
  
      
      const formattedData = response.data.result.map((user, index) => {
        // Basic columns for each user
        const rowData = {
          "Sr.No": index + 1,
          "Name": user.name,
          "Phone no": user.phone_no,         
          "Calendar": user.is_calendar && user.is_calendar.toLowerCase() !== 'null' ? user.is_calendar : '',
          "Person/Village": user.calendar_per_name && user.calendar_per_name.toLowerCase() !== 'null' ? user.calendar_per_name : '',
          "No of Calendar": user.no_calendar && user.no_calendar.toLowerCase() !== 'null' ? user.no_calendar : '',
          "Honored": user.is_honored && user.is_honored.toLowerCase() !== 'null' ? user.is_honored : '',
          "Village": user.per_village && user.per_village.toLowerCase() !== 'null' ? user.per_village : ''
        };

      
    
        // Loop to add dynamic yearly columns based on the minYear and maxYear
        for (let year = minYear; year < maxYear; year++) {
          const yearKey = `${year}-${year + 1}`;
          // Check if the data for that year exists in the response
          rowData[yearKey] = user[`${year}-${year + 1}`] || 0; // Add the yearly amount or 0 if missing
        }
    
        return rowData;
      })

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "calendar-report");
      XLSX.writeFile(workbook, "calendar-report.xlsx");
    } else {
      setLoading(false);
      notification.info({
        message: 'Info',
        description: response.data.message,
        placement: 'topRight'
      });
    }
  };

  // For show image on model large
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const showModal = (image) => {
    setCurrentImage(image || userDummy);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const fetchUserResponses = async (userId, page = 1, limit = 10) => {
    try {
      const response = await axios.get(`${baseUrl}/users/get_last_response/${userId}?page=${page}&limit=${limit}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        }
      });
      if (response.data.status) {
        setResponseData(response.data.result);
        setResponsePagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount
        });
      } else {
        notification.info({
          message: 'Info',
          description: response.data.message,
          placement: 'topRight'
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.error({
        message: 'Error',
        description: error.response?.data?.message,
        placement: 'topRight'
      });
    }
  };

  const showResponseModal = (userId) => {
    setCurrentUserId(userId);
    fetchUserResponses(userId);
    setIsResponseModalVisible(true);
  };

  const handleResponseModalCancel = () => {
    setIsResponseModalVisible(false);
  };

  const handleView = (id) => {
    history.push({
      pathname: `/users/view/${id}`
      
    });
  };


  return (
<>
    {
      loading && (
        <div className="full-page-loader">
          <Spin size="large" />
        </div>
      )
    }
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Calendar Report</span>}
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
          >
            <div className="table-responsive">
              <Table
                columns={columns}
                pagination={false}
                scroll={{ x: 'max-content' }}
                bordered
                title={() => (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Row gutter={[16, 16]}>
                      <Col span={4}>
                        <Input placeholder="Phone" value={filters.phone} onChange={e => handleFilterChange('phone', e.target.value)} />
                      </Col>
                      <Col span={4}>
                        <Input placeholder="Name" value={filters.name} onChange={e => handleFilterChange('name', e.target.value)} />
                      </Col>
                      <Col span={4}>
                        <Input placeholder="Calendar" value={filters.is_calendar} onChange={e => handleFilterChange('is_calendar', e.target.value)} />
                      </Col> 
                      <Col span={3}>
                        <Input placeholder="Person/Village" value={filters.calendar_per_name} onChange={e => handleFilterChange('calendar_per_name', e.target.value)} />
                      </Col>
                      <Col span={3}>
                        <Input placeholder="No Of Calendar" value={filters.no_calendar} onChange={e => handleFilterChange('no_calendar', e.target.value)} />
                      </Col>
                      <Col span={3}>
                        <Input placeholder="Honored" value={filters.is_honored} onChange={e => handleFilterChange('is_honored', e.target.value)} />
                      </Col>
                      
                 
                  

                     

                      <Divider />
                      <Row gutter={16} style={{ marginBottom: '16px', textAlign: 'right' }}>
                        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
                          {/* <Button type="primary" icon={<SearchOutlined />} >
                            Search Report
                          </Button> */}
                          {hasPermission('/reports/calendar-report', 'downloadPermission') && (
                          <Button type="default" icon={<FileExcelOutlined />} onClick={exportToExcel}>
                            Excel Download
                          </Button>
                          )}
                        </Col>
                      </Row>
                      <Divider />
                      <Col xs={24}>
                        <span style={{ marginRight: 10, fontSize: 13 }}>Records per page:</span>
                        <Select defaultValue={20} onChange={handleLimitChange}>
                          <Option value={20}>20</Option>
                          <Option value={40}>40</Option>
                          <Option value={60}>60</Option>
                          <Option value={80}>80</Option>
                          <Option value={100}>100</Option>
                        </Select>
                      </Col>
                    </Row>
                  </div>
                )}
                dataSource={userList.map((user, index) => ({
                  key: (limit * (currentPage - 1)) + index + 1,
                  name: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <Avatar
                        shape="square"
                        size={34}
                        src={user.profile_img || userDummy}
                        icon={!user.profile_img && <UserOutlined />}
                        onClick={() => showModal(user.profile_img || userDummy)}
                        style={{ cursor: 'pointer', borderRadius: 4, flexShrink: 0 }}
                      />
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 13, color: '#7a0000' }}>
                          <Link to={`/users/view/${user.user_id}`} style={{ color: '#1890ff' }}>{user.name}</Link>
                        </div>
                      </div>
                    </div>
                  ),
                  phone_no: (
                    <div>
                      <div style={{ fontWeight: 500, fontSize: 13 }}>{user.phone_no || '—'}</div>
                      {user.alternate_phone_no && <div style={{ fontSize: 11, color: '#888' }}>{user.alternate_phone_no}</div>}
                    </div>
                  ),
                  is_calendar: <span style={{ fontSize: 12 }}>{user.is_calendar && user.is_calendar.toLowerCase() !== 'null' ? user.is_calendar : '—'}</span>,
                  calendar_per_name: <span style={{ fontSize: 12 }}>{user.calendar_per_name && user.calendar_per_name.toLowerCase() !== 'null' ? user.calendar_per_name : '—'}</span>,
                  no_calendar: <span style={{ fontSize: 12 }}>{user.no_calendar && user.no_calendar.toLowerCase() !== 'null' ? user.no_calendar : '—'}</span>,
                  is_honored: <span style={{ fontSize: 12 }}>{user.is_honored && user.is_honored.toLowerCase() !== 'null' ? user.is_honored : '—'}</span>,
                  per_village: <span style={{ fontSize: 12 }}>{user.per_village && user.per_village.toLowerCase() !== 'null' ? user.per_village : '—'}</span>,
                  

               
                }))}
                pagination={{
                  ...pagination,
                  showTotal: total => `Total ${total} records`,
                  style: { marginRight: 20 }
                }}
                onChange={handleTableChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>

      <Modal
        open={isModalVisible}
        footer={null}
        onCancel={handleCancel}
      >
        <img
          src={currentImage}
          alt="Profile"
          style={{ width: '100%' }}
        />
      </Modal>

      <Modal
        open={isResponseModalVisible}
        footer={null}
        onCancel={handleResponseModalCancel}
        width={800}
      >
        <Table
          columns={[
            {
              title: 'Response',
              dataIndex: 'response',
              key: 'response',
              width: 500,
              render: (text) => <div>{text}</div>
            },
            {
              title: 'Date',
              dataIndex: 'createdAt',
              key: 'createdAt',
              render: (text) => <div>{moment(text).format('DD-MM-YYYY')}</div>
            }
          ]}
          dataSource={responseData}
          pagination={{
            ...responsePagination,
            onChange: (page, pageSize) => fetchUserResponses(currentUserId, page, pageSize),
          }}
          rowKey="id"
        />
      </Modal>

    </div>
    </>
  );
}

export default CalendarReport;
